import React from "react";
import ComingSoon from "../../../components/comingSoon/ComingSoon";

const AISkillsLearning = () => {
  const content = "We're working on an exciting new feature to help you assess your AI skills and discover personalized learning interests. This tool will provide comprehensive insights into your AI proficiency levels and recommend tailored learning paths to accelerate your AI career journey. Stay tuned for updates!";

  return (
    <div className="w-full">
      <ComingSoon content={content} />
    </div>
  );
};

export default AISkillsLearning; 